import { render, staticRenderFns } from "./scoreList.vue?vue&type=template&id=2ef85e9f&scoped=true&"
import script from "./scoreList.vue?vue&type=script&lang=js&"
export * from "./scoreList.vue?vue&type=script&lang=js&"
import style0 from "./scoreList.vue?vue&type=style&index=0&id=2ef85e9f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef85e9f",
  null
  
)

export default component.exports